<template>
  <div class="container">
    <div class="card mx-auto mt-5">
      <div class="card-header">
        <strong>{{ $t('brand') }}</strong> - {{ $t('authentification.resetPasswordTitle') }} 
      </div>
      <div class="card-body">        

        <errorMessage v-bind:message="error"></errorMessage>

        <password-input v-bind:action="changePasswordAction"></password-input>

      </div>
    </div>
  </div>
</template>

<script>
import {TokenAuthServiceClient, ResetPasswordModel} from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import ErrorMessage from './ErrorMessage.vue'
import CrudMixin from '../shared/Mixin/CrudMixin'
import PasswordInput from '../shared/components/PasswordInput.vue'

export default {
  name: 'reset-password',
  mixins: [CrudMixin],
  data() {
    let self = this
    let changePasswordAction = function(clean) {
      let code = self.$route.params.code
      let tokenAuthService = ServiceFactory.create(TokenAuthServiceClient)

      tokenAuthService
        .resetPassword(
          new ResetPasswordModel({
            password: this.password,
            passwordResetCode: code,
          })
        )
        .then(res => {
          clean()
          this.$swal({
            title: this.$i18n.t('success'),
            type: 'success',
            timer: 1000,
          })
          this.$router.push({path: '/login'})
        })
        .catch(err => {
          self.processError(err, self)
        })
    }

    return {
      error: '',
      changePasswordAction: changePasswordAction,
    }
  },
  created: function() {},
  methods: {},
  components: {
    errorMessage: ErrorMessage,
    'password-input': PasswordInput,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue